import { authTrustHub } from '@/common/services/modules/auth'

export default {
  methods: {
    async redirectToLink(URL) {
      const isTrusthHubLink = URL.includes('trusthub')
      const isBilling = URL.includes('financeiro')
      const isCBK = URL.includes('//cbk')

      if (!isTrusthHubLink && !isCBK) {
        if (isBilling) return window.open(URL, '_self')
        return window.open(URL, '_blank')
      }

      this.$store.commit('HANDLE_LOADING', true)
      try {
        await authTrustHub()
      } finally {
        this.$store.commit('HANDLE_LOADING', false)
        window.open(URL, '_blank')
      }
    }
  }
}
